import { ILabelProps } from '@smartshell/ui-kit';

import { TYPES_MAP } from 'consts';

import { TLocalesKeys } from '../localization';
import { ETariffType } from '../types';

export const getLabelProps = (
  type: ETariffType
): Omit<ILabelProps, 'text'> & { locale: TLocalesKeys } => {
  const defaultIconProps = {
    locale: TYPES_MAP[type],
    iconProps: { viewBox: '0 0 24 24' },
  };

  switch (type) {
    case 'PACKET': {
      return {
        ...defaultIconProps,
        iconName: 'FixIcon',
      };
    }
    case 'PAUSABLE': {
      return {
        ...defaultIconProps,
        color: 'orange',
        iconName: 'SeasonPassIcon',
      };
    }
    case 'PER_MINUTE': {
      return {
        ...defaultIconProps,
        color: 'violet',
        iconName: 'PerMinuteIcon',
      };
    }
    case 'FIXED': {
      return {
        ...defaultIconProps,
        iconName: 'ClockIcon',
      };
    }
    default: {
      return defaultIconProps;
    }
  }
};
